module.exports = __webpack_public_path__ + "img/Colorization3.f147021f.webp";